// import ar from "./ar";
// import de from "./de";
// import el from "./el";
// import en from "./en";
// import es from "./es";
// import fr from "./fr";
// import he from "./he";
// import it from "./it";
// import nl from "./nl";
// import pl from "./pl";
// import pt from "./pt";
// import ru from "./ru";
// import sv from "./sv";
// import tr from "./tr";
// import tw from "./tw";
// import zh from "./zh";

// export default {
//     ar,
//     de,
//     el,
//     en,
//     es,
//     fr,
//     he,
//     it,
//     nl,
//     pl,
//     pt,
//     ru,
//     sv,
//     tr,
//     tw,
//     zh
// };
import full from "./full.js";
export default full;
